import {
  CONTACT_US_ROUTE,
  GLOBAL_MESSAGING,
  LCW_STATEMENT_OF_INFORMATION_ROUTE,
  OPEN_DEAL_STATUS_HASH,
  PORTFOLIO_ROUTE,
  PROFILE_PERSONAL_DETAILS_ROUTE,
} from 'data/global';
import { Listing } from 'models/Listing';
import { DataRoomShareableLink } from 'models/ShareableLink';
import { LEAD_DRAWER_OPTIONS } from 'router/subrouters/Dash/subrouters/private/subrouters/Portfolio/subrouters/Seller/models';
import { Question } from 'router/subrouters/DataRoom/models/QAndA';
import {
  getBuyingPortfolio,
  getCreateListingRoute,
  getDataRoomRoute,
  getSellingPortfolio,
  getShareableLinkRoute,
  withDataRoomSource,
} from 'utils';
import { DATA_ROOM_LOGIN_SOURCE } from 'models/DataRoomLoginSource';

const getPortfolioRedirectId = (type: 'seller' | 'buyer', listing: Listing) => {
  const { listingEnquiryId, dealRoomId } = listing || {};
  if (type === 'buyer') return listingEnquiryId;
  return dealRoomId;
};

const getQandARedirectId = (question: Question) => {
  const { dataRoomId } = question || {};
  return getDataRoomRoute(
    dataRoomId,
    'questions/questions-and-answers',
    DATA_ROOM_LOGIN_SOURCE.NOTIFICATION,
  );
};

const getFaqRedirectId = (question: Question) => {
  const { dataRoomId } = question || {};
  return getDataRoomRoute(
    dataRoomId,
    'questions/frequently-asked-questions',
    DATA_ROOM_LOGIN_SOURCE.NOTIFICATION,
  );
};

const getLeadRedirectId = (listing: Listing, leadId?: string) =>
  `${getSellingPortfolio(listing.dealRoomId, 'leads')}?leadId=${leadId}&open=${
    LEAD_DRAWER_OPTIONS.PROFILE
  }`;

export const NOTIFICATION_REDIRECTION = {
  // Buyer notification redirections
  0: ({ type, listing }) =>
    `${PORTFOLIO_ROUTE}/${
      NOTIFICATION_USER_TYPE[type]
    }/${getPortfolioRedirectId(type, listing)}/${
      type === 'seller' ? 'listing-information' : ''
    }`,
  1: ({ type, listing }) =>
    `${PORTFOLIO_ROUTE}/${
      NOTIFICATION_USER_TYPE[type]
    }/${getPortfolioRedirectId(type, listing)}/${
      type === 'seller' ? 'listing-information' : ''
    }`,
  2: ({ type, listing }) =>
    `${PORTFOLIO_ROUTE}/${
      NOTIFICATION_USER_TYPE[type]
    }/${getPortfolioRedirectId(type, listing)}/${
      type === 'seller' ? 'listing-information' : ''
    }`,
  3: ({ type, listing }) =>
    `${PORTFOLIO_ROUTE}/${
      NOTIFICATION_USER_TYPE[type]
    }/${getPortfolioRedirectId(type, listing)}/${
      type === 'seller' ? 'listing-information' : ''
    }`,
  4: ({ type, listing }) =>
    `${PORTFOLIO_ROUTE}/${
      NOTIFICATION_USER_TYPE[type]
    }/${getPortfolioRedirectId(type, listing)}/${
      type === 'seller' ? 'listing-information' : ''
    }`,
  5: ({ type, listing }) =>
    `${PORTFOLIO_ROUTE}/${
      NOTIFICATION_USER_TYPE[type]
    }/${getPortfolioRedirectId(type, listing)}/${
      type === 'seller' ? 'listing-information' : ''
    }`,
  6: ({ type, listing }) =>
    `${PORTFOLIO_ROUTE}/${
      NOTIFICATION_USER_TYPE[type]
    }/${getPortfolioRedirectId(type, listing)}/${
      type === 'seller' ? 'listing-information' : ''
    }`,
  7: ({ type, listing }) =>
    `${PORTFOLIO_ROUTE}/${
      NOTIFICATION_USER_TYPE[type]
    }/${getPortfolioRedirectId(type, listing)}/${
      type === 'seller' ? 'listing-information' : ''
    }`,
  8: ({ listing, sessionId = '' }) =>
    `${getBuyingPortfolio(listing.listingEnquiryId, 'messaging')}/${sessionId}`,
  9: ({ listing }) => listing.fullSlugName,
  // Seller notification redirections
  10: ({ type, listing }) =>
    `${PORTFOLIO_ROUTE}/${
      NOTIFICATION_USER_TYPE[type]
    }/${getPortfolioRedirectId(type, listing)}/${
      type === 'seller' ? 'listing-information' : ''
    }`,
  11: ({ type, listing }) =>
    `${PORTFOLIO_ROUTE}/${
      NOTIFICATION_USER_TYPE[type]
    }/${getPortfolioRedirectId(type, listing)}/${
      type === 'seller' ? 'listing-information' : ''
    }`,
  12: ({ type, listing }) =>
    `${PORTFOLIO_ROUTE}/${
      NOTIFICATION_USER_TYPE[type]
    }/${getPortfolioRedirectId(type, listing)}/${
      type === 'seller' ? 'leads' : ''
    }`,
  13: ({ type, listing }) =>
    `${PORTFOLIO_ROUTE}/${
      NOTIFICATION_USER_TYPE[type]
    }/${getPortfolioRedirectId(type, listing)}/${
      type === 'seller' ? 'listing-information' : ''
    }`,
  14: ({ type, listing }) =>
    `${PORTFOLIO_ROUTE}/${
      NOTIFICATION_USER_TYPE[type]
    }/${getPortfolioRedirectId(type, listing)}/${
      type === 'seller' ? 'listing-information' : ''
    }`,
  15: ({ type, listing }) =>
    `${PORTFOLIO_ROUTE}/${
      NOTIFICATION_USER_TYPE[type]
    }/${getPortfolioRedirectId(type, listing)}/${
      type === 'seller' ? 'listing-information' : ''
    }`,
  16: ({ type, listing }) =>
    `${PORTFOLIO_ROUTE}/${
      NOTIFICATION_USER_TYPE[type]
    }/${getPortfolioRedirectId(type, listing)}/${
      type === 'seller' ? 'leads' : ''
    }`,
  17: ({ sessionId }) => `${GLOBAL_MESSAGING}/${sessionId}`,
  18: ({ type, listing }) =>
    `${PORTFOLIO_ROUTE}/${
      NOTIFICATION_USER_TYPE[type]
    }/${getPortfolioRedirectId(type, listing)}/${
      type === 'seller' ? 'listing-information' : ''
    }`,
  19: ({ listing, sessionId = '' }) =>
    `${getBuyingPortfolio(listing.listingEnquiryId, 'messaging')}/${sessionId}`,
  20: ({ listing }) =>
    `${getCreateListingRoute(
      listing.dealRoomId,
      listing._id,
      listing.type,
      true,
    )}/${LCW_STATEMENT_OF_INFORMATION_ROUTE}`,
  21: ({ type, listing }) =>
    `${PORTFOLIO_ROUTE}/${
      NOTIFICATION_USER_TYPE[type]
    }/${getPortfolioRedirectId(type, listing)}/${
      type === 'seller' ? 'leads' : ''
    }`,
  22: ({ type, listing }) =>
    `${PORTFOLIO_ROUTE}/${
      NOTIFICATION_USER_TYPE[type]
    }/${getPortfolioRedirectId(type, listing)}/${
      type === 'seller' ? 'leads' : ''
    }`,
  // This URL is no longer static but we will keep it to support existing notifications
  25: ({ envelopeTemplateUrl }) => envelopeTemplateUrl,

  // Q&A
  27: ({ question }) => getQandARedirectId(question),
  28: ({ question }) => getQandARedirectId(question),
  29: ({ question }) => getQandARedirectId(question),
  30: ({ question }) => getQandARedirectId(question),
  31: ({ question }) => getQandARedirectId(question),
  32: ({ question }) => getQandARedirectId(question),
  33: ({ question }) => getQandARedirectId(question),
  34: ({ question }) => getQandARedirectId(question),
  35: ({ question }) => getQandARedirectId(question),

  // FAQ
  36: ({ question }) => getFaqRedirectId(question),

  // Notes
  37: ({ listing, leadId }) =>
    `${getSellingPortfolio(
      listing.dealRoomId,
      'leads',
    )}?leadId=${leadId}&open=${LEAD_DRAWER_OPTIONS.NOTES}`,

  // RFI
  38: ({ listing }) =>
    getDataRoomRoute(
      listing.dataRoomId,
      'rfi/list',
      DATA_ROOM_LOGIN_SOURCE.NOTIFICATION,
    ),

  // BOSS MODE
  39: ({ listing, sessionId }) =>
    `${getSellingPortfolio(listing.dealRoomId, 'messaging')}/${sessionId}`,
  40: ({ listing }) => getSellingPortfolio(listing.dealRoomId, 'leads'),

  41: ({ listing }) =>
    getDataRoomRoute(
      listing.dataRoomId,
      'documents',
      DATA_ROOM_LOGIN_SOURCE.NOTIFICATION,
    ),
  43: ({ listing }) => getSellingPortfolio(listing.dealRoomId, 'leads'),
  45: ({ listing }) =>
    getDataRoomRoute(
      listing.dataRoomId,
      'members',
      DATA_ROOM_LOGIN_SOURCE.NOTIFICATION,
    ),
  46: ({ listing }) =>
    getDataRoomRoute(
      listing.dataRoomId,
      undefined,
      DATA_ROOM_LOGIN_SOURCE.NOTIFICATION,
    ),
  47: ({ type, listing }) =>
    `${PORTFOLIO_ROUTE}/${
      NOTIFICATION_USER_TYPE[type]
    }/${getPortfolioRedirectId(type, listing)}/${
      type === 'seller' ? 'listing-information' : ''
    }`,
  48: ({ listing }) =>
    `${getSellingPortfolio(listing.dealRoomId, 'deal')}?newNote=true`,
  49: ({ listing }) =>
    `${getSellingPortfolio(
      listing.dealRoomId,
      'deal',
    )}${OPEN_DEAL_STATUS_HASH}`,
  50: ({ listing, dataRoomNodeId }) =>
    withDataRoomSource(
      `${getDataRoomRoute(listing.dataRoomId, 'documents')}${
        dataRoomNodeId ? `/${dataRoomNodeId}` : ''
      }`,
      DATA_ROOM_LOGIN_SOURCE.NOTIFICATION,
    ),

  51: ({ type = 'seller', listing }) =>
    `${PORTFOLIO_ROUTE}/${
      NOTIFICATION_USER_TYPE[type]
    }/${getPortfolioRedirectId(type, listing)}`,

  52: ({ listing }) =>
    getDataRoomRoute(
      listing.dataRoomId,
      'documents',
      DATA_ROOM_LOGIN_SOURCE.NOTIFICATION,
    ),

  54: ({ listing }) =>
    `${getSellingPortfolio(listing.dealRoomId, 'deal')}?newNote=true`,
  55: ({ listing, leadId }) =>
    `${getSellingPortfolio(
      listing.dealRoomId,
      'leads',
    )}?leadId=${leadId}&open=${LEAD_DRAWER_OPTIONS.NOTES}`,

  56: () => CONTACT_US_ROUTE,
  57: ({ listing }) =>
    `${getSellingPortfolio(listing.dealRoomId, 'listing-information')}`,

  58: ({ listing }) =>
    getDataRoomRoute(
      listing.dataRoomId,
      'documents',
      DATA_ROOM_LOGIN_SOURCE.NOTIFICATION,
    ),
  59: ({ listing, leadId }) =>
    `${getSellingPortfolio(
      listing.dealRoomId,
      'leads',
    )}?highlightLeadId=${leadId}`,
  60: ({ listing, leadId }) =>
    `${getSellingPortfolio(
      listing.dealRoomId,
      'leads',
    )}?highlightLeadId=${leadId}`,

  61: ({ shareableLink }) => getShareableLinkRoute(shareableLink?._id),
  62: () => CONTACT_US_ROUTE,

  63: ({ listing }) => getBuyingPortfolio(listing.listingEnquiryId),
  64: ({ listing }) => getSellingPortfolio(listing.dealRoomId, 'leads'),

  65: ({ listing }) => getBuyingPortfolio(listing.listingEnquiryId),
  66: ({ listing }) =>
    getDataRoomRoute(
      listing.dataRoomId,
      'documents',
      DATA_ROOM_LOGIN_SOURCE.NOTIFICATION,
    ),

  67: ({ listing }) =>
    getDataRoomRoute(
      listing.dataRoomId,
      'shareable-links',
      DATA_ROOM_LOGIN_SOURCE.NOTIFICATION,
    ),
  68: ({ listing }) =>
    getDataRoomRoute(
      listing.dataRoomId,
      'waiting-room',
      DATA_ROOM_LOGIN_SOURCE.NOTIFICATION,
    ),
  69: ({ listing, leadId }) => getLeadRedirectId(listing, leadId),
  70: ({ listing, leadId }) => getLeadRedirectId(listing, leadId),
  71: ({ listing, leadId }) => getLeadRedirectId(listing, leadId),
  72: ({ listing, leadId }) => getLeadRedirectId(listing, leadId),
  73: ({ listing, leadId }) => getLeadRedirectId(listing, leadId),
  74: ({ listing, leadId }) => getLeadRedirectId(listing, leadId),
  75: ({ listing, leadId }) => getLeadRedirectId(listing, leadId),
  76: ({ listing, leadId }) => getLeadRedirectId(listing, leadId),
  77: ({ listing, leadId }) => getLeadRedirectId(listing, leadId),
  78: ({ listing, leadId }) => getLeadRedirectId(listing, leadId),
  79: ({ listing, leadId }) => getLeadRedirectId(listing, leadId),

  // Phone number verification transferred - send the previous holder to the
  // profile, where the number now shows as not verified.
  82: () => PROFILE_PERSONAL_DETAILS_ROUTE,

  // Release order completed, lead stayed in the stage.
  83: ({ listing, leadId }) => getLeadRedirectId(listing, leadId),
} as Record<number, (config: NotificationRedirectionProps) => string>;

export const NOTIFICATION_USER_TYPE = {
  seller: 'selling',
  buyer: 'buying',
} as const;
export type ListingUserType = keyof typeof NOTIFICATION_USER_TYPE;

type NotificationRedirectionProps = {
  typeCode: number;
  type: ListingUserType;
  listing: Listing;
  sessionId?: string;
  envelopeTemplateUrl?: string;
  question?: Question;
  leadId?: string;
  dataRoomNodeId?: string;
  shareableLink: DataRoomShareableLink;
};

export const getNotificationRedirectionPath = (
  config: NotificationRedirectionProps,
): string => NOTIFICATION_REDIRECTION[config.typeCode]?.(config);
